import { render } from "./RedirectComponent.vue?vue&type=template&id=3d572b04&scoped=true&ts=true"
import script from "./RedirectComponent.vue?vue&type=script&lang=ts"
export * from "./RedirectComponent.vue?vue&type=script&lang=ts"

import "./RedirectComponent.vue?vue&type=style&index=0&id=3d572b04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d572b04"]])

export default __exports__